<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4" v-if="!cambiarpass">
        <v-card class="elevation-12" v-if="tab === 0">
          <v-toolbar color="fondomenu" dark flat>
            <v-toolbar-title>Ingreso al Sistema</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                @keydown.enter.prevent="login"
                label="email"
                v-model="email"
                prepend-icon="mdi-email"
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="password"
                label="contraseña"
                prepend-icon="mdi-lock"
                @keydown.enter.prevent="login"
                :type="showpass ? 'text' : 'password'"
                :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showpass = !showpass"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="login" color="fondomenu" dark>Ingresar</v-btn>
          </v-card-actions>
          <v-col class="text-center pt-5">
            Todavia no tengo una cuenta
            <v-btn text small @click="tab = 1" color="green" dark
              >Registrarme</v-btn
            >
          </v-col>
        </v-card>
        <v-card class="elevation-12" v-if="tab === 1">
          <v-toolbar color="fondomenu" dark flat>
            <v-toolbar-title>Registro de prestador</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                label="cuit"
                v-model="cuitregistro"
                prepend-icon="mdi-account"
                type="text"
              ></v-text-field>
              <v-text-field
                label="mail"
                v-model="mailregistro"
                prepend-icon="mdi-email"
                type="text"
              ></v-text-field>
              <v-text-field
                label="repita mail"
                v-model="repitamailregistro"
                prepend-icon="mdi-email"
                type="text"
              ></v-text-field>
              {{ errormail }}
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="registrar"
              :disabled="!puederegistrar"
              color="fondomenu"
              >Aceptar</v-btn
            >
            <v-btn @click="tab = 0" color="red" dark>Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" sm="8" md="4" v-if="cambiarpass">
        <v-card class="elevation-12">
          <v-toolbar color="fondomenu" dark flat>
            <v-toolbar-title>Actualizar password</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                v-model="nuevapass"
                label="nueva contraseña"
                prepend-icon="mdi-lock"
                @keydown.enter.prevent="login"
                :type="showpass1 ? 'text' : 'password'"
                :append-icon="showpass1 ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showpass1 = !showpass1"
              ></v-text-field>
              <v-text-field
                v-model="nuevapass2"
                label="nueva contraseña"
                prepend-icon="mdi-lock"
                @keydown.enter.prevent="login"
                :type="showpass2 ? 'text' : 'password'"
                :append-icon="showpass2 ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showpass2 = !showpass2"
              ></v-text-field>
            </v-form>
            <h4 style="color: red">{{ cumplepass }}</h4>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="Guardar"
              :disabled="cumplepass != ''"
              color="fondomenu"
              dark
              >Guardar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import API from '@/lib/API'
import LUM from '../../lib/LUM'
export default {
  data() {
    return {
      tab: 0,
      efector: null,
      email: '',
      password: '',
      showpass: false,
      showpass1: false,
      showpass2: false,
      cambiarpass: false,
      nuevapass: '',
      nuevapass2: '',
      cuitregistro: '',
      mailregistro: '',
      repitamailregistro: '',
    }
  },
  computed: {
    ...mapState('micrositioefectores', ['Usuario']),
    errormail() {
      let ret = ''
      if (!LUM.validateEmail(this.mailregistro)) {
        ret += ' * email incorrecto'
      }
      if (this.mailregistro != this.repitamailregistro) {
        ret += ' * Los mails no coinciden'
      }
      return ret
    },
    puederegistrar() {
      if (this.cuitregistro.length == 11 && this.errormail === '') {
        return true
      }
      return false
    },
    cumplepass() {
      let ret = ''
      if (this.nuevapass != this.nuevapass2) {
        ret = ' * no coinciden las contraseñas'
      } else {
        if (this.nuevapass == '12345') {
          ret = ' * contraseña invalida'
        }
        if (this.nuevapass.length < 6) {
          ret = ' * minimo 6 caracteres'
        }
      }

      return ret
    },
  },
  methods: {
    ...mapActions(['cargarData']),
    ...mapActions('comun', ['inicializar', 'traerUserId']),
    ...mapActions('micrositioefectores', ['loguear', 'logout']),
    ...mapActions('efectores', ['select']),
    registrar() {
      API.UsuariosEfectores.registrar({
        cuit: this.cuitregistro,
        mail: this.mailregistro,
      })
      this.tab = 0      
    },
    async login() {
      if (this.email !== '') {
        await this.loguear({ email: this.email, password: this.password })
        if (this.Usuario) {
          if (this.password == '12345') {
            this.cambiarpass = true
          } else {
            this.efector = await API.Efector.traerUno(this.Usuario.UserId)
            this.cargarDatos()
          }
        }
      } else {
        alert('Ingrese un email valido')
      }
    },
    async cargarDatos() {
      this.select(this.efector)
      await this.inicializar()
      this.cargarData()
      this.traerUserId()
      this.$router.push({ name: 'AutorizacionesMicrositio' })
    },
    async Guardar() {
      this.efector = await API.Efector.traerUno(this.Usuario.UserId)
      let usua = {
        id_efector: this.efector.Id,
        mail: this.efector.EMAIL,
        password: this.nuevapass,
      }
      await API.UsuariosEfectores.modificar(usua)
      this.cargarDatos()
    },
  },
  created() {
    this.logout()
    //  localStorage.removeItem('user');
  },
}
</script>
